import { dashboardDataService } from '../../../services/dashboardDataService';
import { useApiResource } from '../../../utils/useApiResource';
import { DashboardSummaryResponse } from '../types';

/**
 * Hydrates the Dashboard with one aggregated, role-scoped payload from
 * `GET /api/dashboard/summary`. Use this inside the Dashboard shell; individual
 * widgets should receive their slice as props rather than each calling the API.
 *
 * Routes through `dashboardDataService.summary` so that `useApiResource`'s
 * StrictMode-induced double effect collapses to a single HTTP request at the
 * network layer.
 */
export function useDashboardSummary() {
  return useApiResource<DashboardSummaryResponse>(
    (client) => dashboardDataService.summary.get(client),
    [],
    { errorPrefix: 'Failed to load dashboard summary' },
  );
}
